<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-11 15:42:21
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-20 10:49:55
--> 
<template>
  <div>
    <template>
      <v-stepper v-model="e1">
        <v-stepper-header>
          <v-stepper-step :complete="e1 > 1"
                          step="1">{{$t('label_The_general_information')}}</v-stepper-step>

          <v-divider></v-divider>

          <v-stepper-step :complete="e1 > 2"
                          step="2">{{$t('label_propety')}}</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <editGeneral @next='nextstep'></editGeneral>
          </v-stepper-content>

          <v-stepper-content step="2">
            <staffGroup @laststep='laststep'
                        @savesuccess='savesuccess'></staffGroup>
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </template>
  </div>
</template>

<script>
import editGeneral from './editGeneral'
import staffGroup from './staffGroup'
import {
  addStaffPropertyGroup,
} from '@/service/api/staffPropertyGroup.js'
export default {
  components: {
    editGeneral,
    staffGroup
  },
  props: {},
  data () {
    return {
      e1: 1,
      list: {},//editGeneral基本用户输入数据
      mrbase_sys_staff_property_group_default_value: []
    };
  },
  created () { },
  mounted () {
    // console.log('渲染', this.$route, this.$router);
  },
  methods: {
    nextstep (num, list) { //下一步  并获取用户输入数据
      this.e1 = num
      this.list = list
    },
    laststep (v) { //上一步
      this.e1 = v
    },
    async savesuccess (val) {
      this.getPropertyList(val)
      // console.log(this.mrbase_sys_staff_property_group_default_value);
      // return
      // console.log('属性列表数据', val);
      const res = await addStaffPropertyGroup({ ...this.list, mrbase_sys_staff_property_group_default_value: this.mrbase_sys_staff_property_group_default_value })
      if (res.code == 200) {
        this.$Message({ text: this.$t('message_added_successfully') })
        this.$router.push({ name: 'staffPropertyGroup' })
      }
    },
    getPropertyList (val) {
      val.map(item => {
        this.mrbase_sys_staff_property_group_default_value.push(...item.property_list)
        if (Array.isArray(item.children) && item.children.length > 0) {
          this.getPropertyList(item.children)
        }
      })
    }
  },
  computed: {},
  watch: {},
};
</script>

<style scoped>
.v-stepper__content {
  padding: 0;
}
</style>
